import type { ClientDashboardConfig, ResolvedDashboardConfig } from '@/types/dashboard'

type ClientWithDashboard = {
  dashboard?: ClientDashboardConfig
}

export function resolveDashboardConfig(client: ClientWithDashboard): ResolvedDashboardConfig {
  return {
    showMetricIcons: client.dashboard?.showMetricIcons ?? true,
  }
}
